document.addEventListener("DOMContentLoaded", function() {
  // Find alle sektioner, der kan indeholde subkategorier
  const sections = document.querySelectorAll(".subcategory-section-class"); // Udskift med den klasse, der bruges for sektioner

  // Loop gennem hver sektion og skjul dem, hvis de ikke indeholder links
  sections.forEach(function(section) {
    if (!section.querySelector("a")) {
      section.style.display = "none";
    }
  });
});